/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import './static/styles/reset.css'
import './static/styles/global.css'
import './static/styles/font.css'
import './static/styles/colors.css'
import './static/styles/layout.css'

export const onRouteUpdate = () => {
  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  });
};
